import {connect} from 'react-redux';
import report from '../utils/report';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    print: x => x
  },
  {
    title: 'Parent',
    dataIndex: 'parentName',
    key: 'parentId',
    print: x => x || '-'
  },
  {
    title: 'Tax Group',
    dataIndex: 'taxGroupName',
    key: 'taxGroupId',
    print: x => x || '-'
  },
  {
    title: 'Visible on Till',
    key: 'visibleOnTill',
    dataIndex: 'visibleOnTill',
    render: x => x ? 'Yes':'No',
    print: x => x ? 'Yes':'No'
  },
];

export const CategoriesReport = report("Inventory Categories", "categories", columns, 'categoryId',
  (props) => ({
    where: {
      dispensaryId: {eq: props.dispensaryId},
    },
    limit: 10000,
    order: 'name ASC',
  })
);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesReport);



// WEBPACK FOOTER //
// ./src/Category/CategoriesReport.js